// AI Generated
import { Component, Input, OnInit } from '@angular/core';
import { DateTimeService } from '@client/app/services/date-time/date-time.service';

@Component({
    selector: 'table-date',
    template: `
        <div *ngIf="isValid" class="table-date">
            <span class="month">{{ month }}</span>
            <span class="day">{{ day }}</span>
            <span class="year">{{ year }}</span>
        </div>
    `,
    standalone: false,
})
export class TableDateComponent implements OnInit {
    @Input() date?: string | undefined;

    isValid = false;
    day = '';
    month = '';
    year = '';

    constructor (private dateTimeService: DateTimeService) {}

    ngOnInit (): void {
        this.isValid = this.dateTimeService.isValid(this.date);
        if (this.isValid) {
            this.day = this.dateTimeService.format(this.date, 'DD');
            this.month = this.dateTimeService.format(this.date, 'MMM').toUpperCase();
            this.year = this.dateTimeService.format(this.date, 'YYYY');
        }
    }
}
